module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayheavyrain-db0bcaf4ff1c810f25ef64a60bd208f2.webp";